import { render, staticRenderFns } from "./BidDashboardModules.vue?vue&type=template&id=e4b08aee&scoped=true"
import script from "./BidDashboardModules.vue?vue&type=script&lang=js"
export * from "./BidDashboardModules.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardModules.vue?vue&type=style&index=0&id=e4b08aee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b08aee",
  null
  
)

export default component.exports